// extracted by mini-css-extract-plugin
module.exports = {"Header":"BoxHeader_Header__1JfCo","Title":"BoxHeader_Title__2Qppo"};